import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-progress-indicator',
  templateUrl: './progress-indicator.component.html',
  styleUrls: ['./progress-indicator.component.scss'],
  standalone: false,
})
export class ProgressIndicatorComponent {
  @Input() title: string;
  @Input() status: string;
  @Input() progress: number;
  @Input() canCancel: boolean;

  @Output() clickCancel = new EventEmitter<void>();

  onCancel(): void {
    if (!this.isFinished) {
      this.clickCancel.emit();
    }
  }

  get isFinished(): boolean {
    return this.progress === 100 && !this.canCancel;
  }
}
